import { ExternalLink } from 'lucide-react';
import { useLang } from '../i18n';

export function ExternalDistributionLink({ links = [], testid }) {
  const { t } = useLang();
  if (!links.length) return null;
  const keys = { getyourguide: 'distribution.gyg', viator: 'distribution.viator', tourradar: 'distribution.tourradar', tripadvisor: 'distribution.tripadvisor' };
  return <div className="mt-3 space-y-2">{links.map(({ channel, url }) => <a key={channel} href={url} target="_blank" rel="noopener noreferrer sponsored" data-testid={testid} className="eco-btn-secondary min-h-11 w-full justify-center text-xs">
    <ExternalLink size={14} /> {t(keys[channel])}
  </a>)}</div>;
}
